/**
 * Cross-platform `requestIdleCallback` / `cancelIdleCallback`.
 *
 * iOS Safari (where this app also runs on the web) does not implement the
 * idle-callback API, so referencing `requestIdleCallback` directly crashes the
 * whole tree with "Can't find variable: requestIdleCallback". These wrappers
 * fall back to timers when the native API is unavailable.
 */
export const requestIdle: (callback: () => void, options?: { timeout?: number }) => number =
  typeof globalThis.requestIdleCallback === 'function'
    ? globalThis.requestIdleCallback.bind(globalThis)
    : (callback, options) => setTimeout(callback, options?.timeout ?? 1) as unknown as number;

export const cancelIdle: (handle: number) => void =
  typeof globalThis.cancelIdleCallback === 'function'
    ? globalThis.cancelIdleCallback.bind(globalThis)
    : handle => clearTimeout(handle);
